<template>
  <div>
    <v-card>
      <v-card-title>
        Cursos
        <v-spacer></v-spacer>
        <v-layout row wrap justify-end>
          <v-flex xs5 px-1>
            <v-text-field
              v-model="search_filter"
              append-icon="search"
              :label="$t('extracurriculares.register.search')"
              clearable
            ></v-text-field>
          </v-flex>
          <v-flex xs3 px-1>
            <v-select
              v-model="status_filter"
              :items="status_items"
              :label="$t('extracurriculares.courses.form.status')"
              clearable
            ></v-select>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="courses_to_show"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.name }}</td>
          <td class="text-xs-center">${{ formatNumber(props.item.course_type.payment_type == 'course_payment' ? props.item.price : props.item.course_type.price) }}</td>
          <td class="text-xs-center">{{ props.item.activequota }}</td>
          <td class="text-xs-center">{{ props.item.availablequotas }}</td>
          <td class="text-xs-center">
            <v-btn
              @click="registrationDates(props.item)"
              outline
              color="primary">
              Fechas de inscripción
            </v-btn>
          </td>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog
      v-model="detail_dialog"
      transition="dialog-transition"
    >
      <v-card>
        <register-dates-detail
          :course="course_detail"
          v-on:updateCoursesList="init"
        ></register-dates-detail>
        <v-layout row justify-center>
            <v-btn
            @click="detail_dialog = false"
            color="primary">close</v-btn>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import registerDatesDetail from './enrollment_registration_dates'
  export default {
    name: 'enrollment-admin-view',
    components: {
      'register-dates-detail': registerDatesDetail,
    },
    data() {
      return {
        courses: [],
        courses_to_show: [],
        status_items: [
          { value: 1, text: 'Activo' },
          { value: 0, text: 'Inactivo' },
        ],
        search_filter: '',
        status_filter: '',
        headers: [
          { text: 'Curso', value: 'name', align: 'center' },
          { text: 'Precio', value: 'price', align: 'center' },
          { text: 'Cupo', value: 'quota', align: 'center' },
          { text: 'Disponible', value: 'available', align: 'center' },
          { text: 'Acciones', value: 'actions', align: 'center' },
        ],
        course_detail: {},
        detail_dialog: false
      }
    },
    watch: {
      search_filter() {
        this.filter_courses()
      },
      status_filter() {
        this.filter_courses()
      },
    },
    created () {
      this.init();
    },
    methods: {
      filter_courses() {
        let courses_to_show = this.courses

        if (this.search_filter && this.search_filter.trim() !== '') {
          courses_to_show = courses_to_show
            .filter(course => course.name.toUpperCase().indexOf(this.search_filter.toUpperCase()) > -1)
        }

        if ((this.status_filter && this.status_filter !== '') || this.status_filter === 0) {
          courses_to_show = courses_to_show.filter(course => course.status === this.status_filter)
        }

        this.courses_to_show = courses_to_show
      },
      init() {
        axios.get('/api/extracurriculares/enrollment/admin')
          .then(resp => {
            if (resp.status === 200) {
              this.courses = resp.data.courses
              this.courses_to_show = resp.data.courses
            }
          })
      },
      formatNumber(number) {
        if(!number || typeof number === 'undefined') {
            return 0;
        } else {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
      },
      registrationDates(course) {
        this.course_detail = course
        this.detail_dialog = true
      },
      getQuota(quota, schedules) {
        const schedulesCount = schedules ? schedules.length : 0
        return quota * schedulesCount
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/extracurriculares/admin/enrollment.vue